export default "__VITE_ASSET__CewzCT4L__"